import { Card, Divider, Image, Row, Space, Tag, Typography } from "antd";
import React from "react";
const { Title } = Typography;
export const WhatsNewPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card
        style={{
          borderRadius: 16,
          marginBottom: 24,
          maxWidth: 750,
        }}
      >
        <Title level={3}>Changelog</Title>
        <Divider />
        <Space size={16} direction="vertical">
          <Row>
            <Tag color="orange">15.06.2026</Tag>
            <Tag color="orange">1.0.5</Tag>
          </Row>
          <Typography>
            <Title level={4}>Основні зміни</Title>
            <ul>
              <li>
                Виправлено баг з перекладом сторінок через перекладач, коли при
                перекладі сторінки ламались окремі компоненти. Сайт є
                одноязичним.
              </li>
              <li>
                При завантаженні кошторису з роботами під проект покращено
                розпізнавання робіт, підлаштовуючись під різні формати
                кошторисів з 1С
              </li>
            </ul>
          </Typography>
        </Space>
        <Divider />
        <Space size={16} direction="vertical">
          <Row>
            <Tag color="orange">13.06.2026</Tag>
            <Tag color="orange">1.0.4</Tag>
          </Row>
          <Typography>
            <Title level={4}>Основні зміни</Title>
            <ul>
              <li>Можливість додавати матеріали під проект для інженера</li>
              <li>Монтер може додавати у бланк використані матеріали</li>
              <li>
                <Image
                  width={300}
                  alt="tableDownload"
                  src="/img/whatsnew/addedMaterials.png"
                />
              </li>
              <li>
                <Image
                  width={300}
                  alt="tableDownload"
                  src="/img/whatsnew/addedMaterialsToCreateForm.png"
                />
              </li>
            </ul>
          </Typography>
        </Space>
        <Divider />
        <Space size={16} direction="vertical">
          <Row>
            <Tag color="orange">13.06.2026</Tag>
            <Tag color="orange">1.0.3</Tag>
          </Row>
          <Typography>
            <Title level={4}>Основні зміни</Title>
            <ul>
              <li>
                Можливість вибору всіх робіт при подачі бланку та відображення
                робіт що не були в кошторисі
              </li>
              <li>
                У монтерів тепер є можливість вибирати будь-які роботи з
                кошторису, при цьому роботи що не були в кошторисі, будуть
                окремо виділятись у вкладці "Роботи" для інженера
              </li>
              <li>
                <Image
                  width={300}
                  alt="tableDownload"
                  src="/img/whatsnew/worksWithoutEstimate.png"
                />
              </li>
            </ul>
          </Typography>
        </Space>
        <Divider />
        <Space size={16} direction="vertical">
          <Row>
            <Tag color="orange">01.06.2026</Tag>
            <Tag color="orange">1.0.2</Tag>
          </Row>
          <Typography>
            <Title level={4}>Основні зміни</Title>
            <ul>
              <li>Додано можливість скачувати таблицю з даними проекту</li>
              <li>
                Для скачування спочатку потрібно вибрати діапазон дат, а також
                налаштувати фільтрацію
              </li>
              <li>
                <Image
                  width={300}
                  alt="tableDownload"
                  src="/img/whatsnew/tableDownload.png"
                />
              </li>
            </ul>
          </Typography>
        </Space>
        <Divider />
        <Space size={16} direction="vertical">
          <Row>
            <Tag color="orange">30.05.2026</Tag>
            <Tag color="orange">1.0.1</Tag>
          </Row>
          <Typography>
            <Title level={4}>Основні зміни</Title>
            <ul>
              <li>
                Оновлено візуальний вигляд розділення робіт по групам при
                додаванні робіт
              </li>
              <li>
                <Image
                  width={300}
                  alt="groupedWorks"
                  src="/img/whatsnew/groupedWorks.png"
                />
              </li>
              <li>
                Додано можливість завантажувати кошторис з роботами при
                створенні/оновленні проекту
              </li>
              <li>
                <Image
                  width={300}
                  alt="basic"
                  src="/img/whatsnew/upload1CEstimate.png"
                />
              </li>
            </ul>
          </Typography>
        </Space>
      </Card>
    </div>
  );
};
